import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-icon-done',
    templateUrl: './done.component.svg',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DoneComponent {}
